import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import IconBot from "@/assets/icons/bot.svg?react";
import Button from "@/components/ui/Button";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  openChatModal: () => void;
  toastId: string | number;
}

const ChatNotification: React.FC<Props> = ({ className = "", openChatModal, toastId }) => {
  const { t } = useTranslation("voiceek_ui");

  const handleClickShowResult = () => {
    openChatModal();
    toast.dismiss(toastId);
  };

  return (
    <div
      className={cn(
        "flex flex-col items-center w-50 h-50 px-5 pt-4 pb-2.5 rounded-[10px]",
        "bg-[#475B91] text-white text-center font-bold leading-[18px]",
        className,
      )}
    >
      <IconBot className="w-24 h-24 fill-white" />
      <span className="whitespace-pre-line">{t("chat.notificationMessage")}</span>
      <Button variant="readmore" className="w-40 h-10 mt-2 cursor-pointer" onClick={handleClickShowResult}>
        {t("chat.showResult")}
      </Button>
    </div>
  );
};

export default ChatNotification;
